module.exports = __webpack_public_path__ + "img/irealcareErweima.acd97764.svg";